const apiUrlRaw: unknown = import.meta.env.VITE_API_URL;
const dashboardUrlRaw: unknown = import.meta.env.VITE_DASHBOARD_URL;

export const API_URL = typeof apiUrlRaw === 'string' ? apiUrlRaw : '';
export const DASHBOARD_URL =
  typeof dashboardUrlRaw === 'string' && dashboardUrlRaw.trim().length > 0
    ? dashboardUrlRaw
    : 'http://localhost:5173';

export async function apiFetch(
  path: string,
  init?: RequestInit
): Promise<Response> {
  return fetch(`${API_URL}${path}`, {
    ...init,
    credentials: 'include',
    headers: {
      ...(init?.headers || {}),
    },
  });
}

export async function readErrorMessage(
  response: Response,
  fallback: string
): Promise<string> {
  try {
    const payload = (await response.json()) as {
      message?: string;
      error?: string;
    };
    if (payload?.message) return payload.message;
    if (payload?.error) return payload.error;
  } catch {
    // noop
  }
  return fallback;
}
